import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';
import {
  fetchSchoolCycles,
  createSchoolCycle,
  updateSchoolCycle,
  deleteSchoolCycle,
} from '../../helpers/KnGroupsOptions';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnPagination,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      schoolCycle: {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      schoolCycles: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.schoolCycle);
    },
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedSchoolCycles(1);
    this.schoolCycle.id_autor = this.userData.id;
    this.schoolCycle.id_institucion_educativa = this.institutionId;
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginatedSchoolCycles(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedSchoolCycles(1);
        this.schoolCycle.id_autor = this.userData.id;
        this.schoolCycle.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedSchoolCycles(page = 1) {
      try {
        this.schoolCycles = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchSchoolCycles({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const schoolCycle of data) {
              this.schoolCycles.push({ ...schoolCycle });
            }
          } else {
            console.error(
              'No se pudieron obtener los ciclos escolares',
              message
            );
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los ciclos escolares:', error);
        this.loading = false;
      }
    },

    async save() {
      if (this.toUpdate) {
        await updateSchoolCycle(
          this.schoolCycle.id,
          this.schoolCycle.dato,
          this.schoolCycle.fecha_inicio,
          this.schoolCycle.fecha_fin,
          this.schoolCycle.id_institucion_educativa
        );
        this.toUpdate = false;
        await this.getPaginatedSchoolCycles(1);
      } else {
        await createSchoolCycle(
          this.schoolCycle.dato,
          this.schoolCycle.fecha_inicio,
          this.schoolCycle.fecha_fin,
          this.schoolCycle.id_institucion_educativa
        );
        this.clear();
        await this.getPaginatedSchoolCycles(1);
      }
      this.clear();
    },
    clear() {
      this.schoolCycle = {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.schoolCycle = {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    edit(item) {
      this.schoolCycle = { ...item };
      // console.log("Item a editar:", this.schoolCycle);
      this.toUpdate = true;
    },
    async deleteInline(itemId) {
      await deleteSchoolCycle(itemId);
      await this.getPaginatedSchoolCycles(1);
      this.clearInline();
    },
  },
};
